module.exports = __webpack_public_path__ + "img/Cuban_Sandwich_Chicken.35ec2c6a.jpg";